"use client";

import { usePathname } from "next/navigation";
import { markAuthStore, selectIsUserLoggedIn } from "stores/auth/authSlice";
import { useAppDispatch, useAppSelector } from "stores/hooks";
export const LogInToPortalButton = ({
  className = ""
}: {
  className?: string;
}) => {
  const isLoggedIn = useAppSelector(selectIsUserLoggedIn);
  const pathname = usePathname();
  const dispatch = useAppDispatch();
  if (isLoggedIn) return null;
  const isPaymentPage = pathname?.startsWith("/payment");
  const handleClick = () => {
    if (isPaymentPage) return;
    dispatch(markAuthStore({
      ui: {
        isLoginFlow: true,
        isSigningUpWithEmail: true,
        modalType: "LOGIN_WITH_EMAIL"
      }
    }));
  };
  return <button onClick={handleClick} className={`btn btn-ghost hidden h-12 whitespace-nowrap rounded-full px-6 text-base font-medium text-white outline-none hover:bg-[rgba(0,0,0,0.2)] hover:text-white hover:shadow-none active:bg-[rgba(0,0,0,0.6)] lg:flex ${className}`} data-sentry-component="LogInToPortalButton" data-sentry-source-file="LogInToPortalButton.tsx">
      Log in to portal
    </button>;
};